import tw from "twin.macro";
// import { ReactComponent as Heart } from "images/star-icon.svg";
// import { ReactComponent as Hand } from "images/hand.svg";
import { getCustomerId } from "../utility/HeaderConfig";
import {
  productLikeCount,
  productWishCount,
  deleteCustomerLike,
  createCustomerLike,
  createCustomerWish,
  deleteCustomerWish,
} from "api/Like&WishCountApi";
import styled from "styled-components";
import { useEffect, useState } from "react";
import { useCartContext } from "context/UseCartContext";

// eslint-disable-next-line
const CardRatingContainer = tw.div`cursor-pointer ml-4 `;
const CardRating = styled.div`
  ${tw`flex items-center justify-center cursor-pointer rounded-full bg-white`}
  width: 25px;
  height: 25px;
  position: relative;
  transition: all 0.25s ease;

  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

  &:hover {
    transform: scale(1.1);
  }

  &.like-active {
    background: #fad8df;
    color: #f57f98;
  }

  &.wish-active {
    background: #f5d17e;
    color: #ffffff;
  }
`;

export default (props) => {
  const [Like, setLike] = useState(false);
  const [Wish, setWish] = useState(false);
  const [LikeCount, setLikeCount] = useState(props.categoryItem.likesCount);
  const [WishCount, setWishCount] = useState(props.categoryItem.wishListCount);

  const { dispatch } = useCartContext();

  useEffect(() => {
    const productCustomerLike = () => {
      if (
        getCustomerId() !== "onlinepayment" &&
        getCustomerId() !== "" &&
        getCustomerId() !== null &&
        getCustomerId() !== undefined
      ) {
        const likeWishFilter = `customerId=${getCustomerId()}&productId=${
          props.common && props.categoryItem.productId
            ? props.categoryItem.productId
            : props.categoryItem.id
        }`;
        productLikeCount(likeWishFilter).then((data) => {
          if (data.response > 0) {
            setLike(true);
          }
        });
        productWishCount(likeWishFilter).then((item) => {
          if (item.response.length > 0) {
            setWish(true);
          }
        });
      }
    };
    productCustomerLike();
    //eslint-disable-next-line
  }, [props.categoryItem.id]);

  const wishCountFunc = () => {
    if (
      getCustomerId() !== "onlinepayment" &&
      getCustomerId() !== "" &&
      getCustomerId() !== null &&
      getCustomerId() !== undefined
    ) {
      if (Wish) {
        setWish(false);
        setWishCount(WishCount - 1);
        const deletWish = `customerId=${getCustomerId()}&productId=${
          props.common && props.categoryItem.productId
            ? props.categoryItem.productId
            : props.categoryItem.id
        }`;
        deleteCustomerWish(deletWish);
      } else {
        setWish(true);
        setWishCount(WishCount + 1);
        const createWish = `customerId=${getCustomerId()}&productId=${
          props.common && props.categoryItem.productId
            ? props.categoryItem.productId
            : props.categoryItem.id
        }&remark=${"liked"}`;
        createCustomerWish(createWish);
      }
    } else {
      dispatch({ type: "MODAL", payload: "login" });
    }
  };

  const likeCountFunc = () => {
    if (
      getCustomerId() !== "onlinepayment" &&
      getCustomerId() !== "" &&
      getCustomerId() !== null &&
      getCustomerId() !== undefined
    ) {
      if (Like) {
        setLike(false);
        setLikeCount(LikeCount - 1);
        const deletLike = `customerId=${getCustomerId()}&productId=${
          props.common && props.categoryItem.productId
            ? props.categoryItem.productId
            : props.categoryItem.id
        }`;
        deleteCustomerLike(deletLike);
      } else {
        setLike(true);
        setLikeCount(LikeCount + 1);
        const createLike = `customerId=${getCustomerId()}&productId=${
          props.common && props.categoryItem.productId
            ? props.categoryItem.productId
            : props.categoryItem.id
        }&remark=${"liked"}`;
        createCustomerLike(createLike);
      }
    } else {
      dispatch({ type: "MODAL", payload: "login" });
    }
  };

  return (
    <>
      <div tw="flex absolute top-0 right-0 m-3 gap-2 z-20">
        {/* LIKE */}
        <CardRating
          className={`${Like ? "like-active" : ""}`}
          onClick={likeCountFunc}
          style={{ padding: "12px" }}
        >
          <i
            style={{ fontSize: "11px" }}
            className={`bi ${Like ? "bi-hand-thumbs-up-fill " : "bi-hand-thumbs-up "}`}
          />

          {LikeCount > 0 && (
            <span style={{ fontSize: "10px" }} className="count-badge">
              {LikeCount}
            </span>
          )}
        </CardRating>
        {/* WISHLIST */}
        <CardRating
          className={`${Wish ? "wish-active" : ""}`}
          onClick={wishCountFunc}
          style={{ padding: "12px" }}
        >
          <i
            style={{ fontSize: "10px" }}
            className={`bi ${Wish ? "bi-heart-fill " : "bi-heart "}`}
          />

          {WishCount > 0 && (
            <span style={{ fontSize: "10px" }} className="count-badge">
              {WishCount}
            </span>
          )}
        </CardRating>
      </div>
    </>
  );
};